// import React, { useState } from 'react';
// import axios from 'axios';
// import * as XLSX from 'xlsx';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Swal from 'sweetalert2';

// const API_URL = process.env.REACT_APP_API;

// const FrieghtSummary = ({ fromDate, toDate, companyCode, yearCode, accode }) => {
//     const [loading, setLoading] = useState(false);

//     const columns = [
//         'Challan_No', 'DO_No', 'Date', 'Mill_Code', 'MillName', 'MillStateCode',
//         'Billed_To', 'BillToName', 'BillToStateCode', 'TransportName',
//         'TransportStateCode', 'Vehicle_No', 'Quintal', 'Rate', 'Amount',
//         'CGST', 'SGST', 'IGST', 'FinalAmount',
//     ];

//     const fetchFrieghtSummary = async () => {
//         try {
//             setLoading(true);
//             const response = await axios.get(`${API_URL}/frieghtbill-summary`, {
//                 params: {
//                     from_date: fromDate,
//                     to_date: toDate,
//                     Company_Code: companyCode,
//                     Year_Code: yearCode,
//                     accode: accode
//                 },
//             });

//             if (response.data.length === 0) {
//                 Swal.fire({
//                     icon: 'error',
//                     title: 'Data Not Found!',
//                     text: 'No Freight Summary data found.',
//                 });
//                 return;
//             }

//             openReportInNewTab(response.data);
//         } catch (err) {
//             Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch data' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const openReportInNewTab = (data) => {
//         const reportWindow = window.open('', '_blank');
//         if (!reportWindow) return;

//         // Calculate Totals for the report
//         const totals = data.reduce((acc, row) => ({
//             Quintal: acc.Quintal + parseFloat(row.Quintal || 0),
//             Amount: acc.Amount + parseFloat(row.Amount || 0),
//             CGST: acc.CGST + parseFloat(row.CGST || 0),
//             SGST: acc.SGST + parseFloat(row.SGST || 0),
//             IGST: acc.IGST + parseFloat(row.IGST || 0),
//             FinalAmount: acc.FinalAmount + parseFloat(row.FinalAmount || 0),
//         }), { Quintal: 0, Amount: 0, CGST: 0, SGST: 0, IGST: 0, FinalAmount: 0 });

//         reportWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Freight Bill Summary Report</title>
//                     <style>
//                         body { font-family: Arial, sans-serif; padding: 20px; }
//                         table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 12px; }
//                         th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
//                         th { background-color: #f2f2f2; }
//                         .total-row { font-weight: bold; background-color: #ffffcc; }
//                         .btn-container { margin-bottom: 20px; text-align: center; }
//                         button { padding: 10px 20px; cursor: pointer; background: #28a745; color: white; border: none; border-radius: 4px; }
//                     </style>
//                 </head>
//                 <body>
//                     <h2 style="text-align: center;">Freight Bill Summary Report</h2>
//                     <div class="btn-container">
//                         <button onclick="window.exportToExcel()">Export to Excel</button>
//                     </div>
//                     <table>
//                         <thead>
//                             <tr>${columns.map(c => `<th>${c}</th>`).join('')}</tr>
//                         </thead>
//                         <tbody>
//                             ${data.map(row => `
//                                 <tr>${columns.map(c => `<td>${row[c] || ''}</td>`).join('')}</tr>
//                             `).join('')}
//                             <tr class="total-row">
//                                 <td colspan="12" style="text-align: right;">Totals:</td>
//                                 <td>${totals.Quintal.toFixed(2)}</td>
//                                 <td></td>
//                                 <td>${totals.Amount.toFixed(2)}</td>
//                                 <td>${totals.CGST.toFixed(2)}</td>
//                                 <td>${totals.SGST.toFixed(2)}</td>
//                                 <td>${totals.IGST.toFixed(2)}</td>
//                                 <td>${totals.FinalAmount.toFixed(2)}</td>
//                             </tr>
//                         </tbody>
//                     </table>
//                     <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
//                     <script>
//                         window.exportToExcel = function() {
//                             const ws = XLSX.utils.json_to_sheet(${JSON.stringify(data)});
//                             const wb = XLSX.utils.book_new();
//                             XLSX.utils.book_append_sheet(wb, ws, 'Report');
//                             XLSX.writeFile(wb, 'FreightSummary.xlsx');
//                         }
//                     </script>
//                 </body>
//             </html>
//         `);
//         reportWindow.document.close();
//     };

//     return (
//         <div className="text-center">
//             <button
//                 className="btn btn-primary"
//                 onClick={fetchFrieghtSummary}
//                 disabled={loading}
//                  style={{
//                     width: '20%',
//                     height: '60px',
//                 }}
//             >
//                 {loading ? 'Loading...' : 'Freight Bill Summary'}
//             </button>
//         </div>
//     );
// };

// export default FrieghtSummary;
















import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API;

const FrieghtSummary = ({ fromDate, toDate, companyCode, yearCode, accode }) => {
    const [loading, setLoading] = useState(false);

    const columns = [
        'Challan_No', 'DO_No', 'Date', 'Mill_Code', 'MillName', 'MillStateCode',
        'Billed_To', 'BillToName', 'BillToStateCode', 'TransportName',
        'TransportStateCode', 'Vehicle_No', 'Quintal', 'Rate', 'Amount',
        'CGST', 'SGST', 'IGST', 'FinalAmount',
    ];

    const fetchFrieghtSummary = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}/frieghtbill-summary`, {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                    Company_Code: companyCode,
                    Year_Code: yearCode,
                    accode: accode
                },
            });

            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found!',
                    text: 'No Freight Summary data found.',
                });
                return;
            }

            openReportInNewTab(response.data);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch data' });
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = (data) => {
        // Reorder data according to columns array
        const orderedData = data.map(row => {
            const orderedRow = {};
            columns.forEach(col => {
                orderedRow[col] = row[col] || '';
            });
            return orderedRow;
        });

        // Calculate Totals
        const totals = data.reduce((acc, row) => ({
            Quintal: acc.Quintal + parseFloat(row.Quintal || 0),
            Amount: acc.Amount + parseFloat(row.Amount || 0),
            CGST: acc.CGST + parseFloat(row.CGST || 0),
            SGST: acc.SGST + parseFloat(row.SGST || 0),
            IGST: acc.IGST + parseFloat(row.IGST || 0),
            FinalAmount: acc.FinalAmount + parseFloat(row.FinalAmount || 0),
        }), { Quintal: 0, Amount: 0, CGST: 0, SGST: 0, IGST: 0, FinalAmount: 0 });

        // Add totals row
        const totalsRow = {};
        columns.forEach(col => {
            if (col === 'Quintal') totalsRow[col] = totals.Quintal.toFixed(2);
            else if (col === 'Amount') totalsRow[col] = totals.Amount.toFixed(2);
            else if (col === 'CGST') totalsRow[col] = totals.CGST.toFixed(2);
            else if (col === 'SGST') totalsRow[col] = totals.SGST.toFixed(2);
            else if (col === 'IGST') totalsRow[col] = totals.IGST.toFixed(2);
            else if (col === 'FinalAmount') totalsRow[col] = totals.FinalAmount.toFixed(2);
            else totalsRow[col] = '';
        });
        totalsRow['Challan_No'] = 'TOTALS';

        orderedData.push(totalsRow);

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(orderedData, { header: columns });

        // Set column widths for better readability
        const colWidths = columns.map(col => ({ wch: 15 }));
        ws['!cols'] = colWidths;

        // Create workbook and save
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Freight Summary');
        XLSX.writeFile(wb, `FreightSummary_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const openReportInNewTab = (data) => {
        const reportWindow = window.open('', '_blank');
        if (!reportWindow) return;

        // Calculate Totals for the report
        const totals = data.reduce((acc, row) => ({
            Quintal: acc.Quintal + parseFloat(row.Quintal || 0),
            Amount: acc.Amount + parseFloat(row.Amount || 0),
            CGST: acc.CGST + parseFloat(row.CGST || 0),
            SGST: acc.SGST + parseFloat(row.SGST || 0),
            IGST: acc.IGST + parseFloat(row.IGST || 0),
            FinalAmount: acc.FinalAmount + parseFloat(row.FinalAmount || 0),
        }), { Quintal: 0, Amount: 0, CGST: 0, SGST: 0, IGST: 0, FinalAmount: 0 });

        reportWindow.document.write(`
            <html>
                <head>
                    <title>Freight Bill Summary Report</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 12px; }
                        th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                        .total-row { font-weight: bold; background-color: #ffffcc; }
                        .btn-container { margin-bottom: 20px; text-align: center; }
                        button { padding: 10px 20px; cursor: pointer; background: #28a745; color: white; border: none; border-radius: 4px; margin: 0 5px; }
                        .print-btn { background: #007bff; }
                    </style>
                </head>
                <body>
                    <h2 style="text-align: center;">Freight Bill Summary Report</h2>
                    <div class="btn-container">
                        <button onclick="window.exportToExcel()">Export to Excel</button>
                        <button class="print-btn" onclick="window.print()">Print</button>
                    </div>
                    <table id="reportTable">
                        <thead>
                            <tr>${columns.map(c => `<th>${c}</th>`).join('')}</tr>
                        </thead>
                        <tbody>
                            ${data.map(row => `
                                <tr>${columns.map(c => `<td>${row[c] || ''}</td>`).join('')}</tr>
                            `).join('')}
                            <tr class="total-row">
                                <td colspan="12" style="text-align: right;">Totals:</td>
                                <td>${totals.Quintal.toFixed(2)}</td>
                                <td></td>
                                <td>${totals.Amount.toFixed(2)}</td>
                                <td>${totals.CGST.toFixed(2)}</td>
                                <td>${totals.SGST.toFixed(2)}</td>
                                <td>${totals.IGST.toFixed(2)}</td>
                                <td>${totals.FinalAmount.toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <script>
                        window.exportToExcel = function() {
                            const data = ${JSON.stringify(data)};
                            const columns = ${JSON.stringify(columns)};
                            
                            // Reorder data according to columns array
                            const orderedData = data.map(row => {
                                const orderedRow = {};
                                columns.forEach(col => {
                                    orderedRow[col] = row[col] || '';
                                });
                                return orderedRow;
                            });
                            
                            // Calculate totals
                            const totals = {
                                Quintal: ${totals.Quintal},
                                Amount: ${totals.Amount},
                                CGST: ${totals.CGST},
                                SGST: ${totals.SGST},
                                IGST: ${totals.IGST},
                                FinalAmount: ${totals.FinalAmount}
                            };
                            
                            // Add totals row
                            const totalsRow = {};
                            columns.forEach(col => {
                                if (col === 'Quintal') totalsRow[col] = totals.Quintal.toFixed(2);
                                else if (col === 'Amount') totalsRow[col] = totals.Amount.toFixed(2);
                                else if (col === 'CGST') totalsRow[col] = totals.CGST.toFixed(2);
                                else if (col === 'SGST') totalsRow[col] = totals.SGST.toFixed(2);
                                else if (col === 'IGST') totalsRow[col] = totals.IGST.toFixed(2);
                                else if (col === 'FinalAmount') totalsRow[col] = totals.FinalAmount.toFixed(2);
                                else totalsRow[col] = '';
                            });
                            totalsRow['Challan_No'] = 'TOTALS';
                            
                            orderedData.push(totalsRow);
                            
                            // Create worksheet
                            const ws = XLSX.utils.json_to_sheet(orderedData, { header: columns });
                            
                            // Set column widths
                            const colWidths = columns.map(col => ({ wch: 15 }));
                            ws['!cols'] = colWidths;
                            
                            // Create workbook and save
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, 'Freight Summary');
                            XLSX.writeFile(wb, 'FreightSummary_' + new Date().toISOString().slice(0,10) + '.xlsx');
                        }
                    </script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
                </body>
            </html>
        `);
        reportWindow.document.close();
    };

    return (
        <div className="text-center">
            <button
                className="btn btn-primary"
                onClick={fetchFrieghtSummary}
                disabled={loading}
                style={{
                    width: '20%',
                    height: '60px',
                }}
            >
                {loading ? 'Loading...' : 'Freight Bill Summary'}
            </button>
        </div>
    );
};

export default FrieghtSummary;